export const SERVER_SIDE_SEARCH_LIMIT = 100;
